import { Clickable, Img, Layout, Text } from 'ds';

interface OfficeExperienceCardProps {
  title: string;
  onClick: () => void;
  srcKey: string;
}

const OfficeExperienceCard = ({ title, onClick, srcKey }: OfficeExperienceCardProps) => {
  return (
    <Clickable onClick={onClick} style={{ width: 224, height: 212 }}>
      <Layout flex direction="column" gap={12} height="100%">
        <Layout
          width={224}
          height={160}
          color={title === 'AI office assistant' ? 'purple-gradient-transparent' : 'gray-25'}
          borderRadius={16}
          align="center"
          justify="center"
        >
          <Layout flex justify="center" align="center">
            {title === 'AI office assistant' ? (
              <Layout flex direction="row" gap={12} align="center">
                <Layout width={62} height={62} minWidth={62} minHeight={62}>
                  <Img srcKey={srcKey} alt="thinking" width={600} height={600} folder="ux" />
                </Layout>
                <Text
                  color="purple-gradient"
                  __style={{ fontSize: '29.85px', fontWeight: 400, lineHeight: '44.78px', letterSpacing: '0%' }}
                >
                  Hello.
                </Text>
              </Layout>
            ) : (
              <Layout flex justify="center" align="center" width={224} height={160}>
                <Img alt="Office Experience" srcKey={srcKey} width={672} height={480} folder="ux" />
              </Layout>
            )}
          </Layout>
        </Layout>
        <Text size="body-sm" color="gray-700" align="left">
          {title}
        </Text>
      </Layout>
    </Clickable>
  );
};

export default OfficeExperienceCard;
